var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useRef, cloneElement } from 'react';
import { ScreenReaderOnly } from '../screen-reader-only';
import { Paragraph } from '../paragraph';
import { NotificationCard } from '../notification-card';
import { Heading } from '../heading';
import useInternalLayout from './use-internal-layout';
import { notificationStyle, contentStyle, titleStyle, descriptionStyle, textContentStyle, actionStyle, } from './styles';
function Card(_a) {
    var isVisible = _a.isVisible, title = _a.title, description = _a.description, mode = _a.mode, variant = _a.variant, inverted = _a.inverted, closable = _a.closable, onClose = _a.onClose, closeButtonOverride = _a.closeButtonOverride, action = _a.action, restProps = __rest(_a, ["isVisible", "title", "description", "mode", "variant", "inverted", "closable", "onClose", "closeButtonOverride", "action"]);
    var cardRef = useRef(null);
    var layout = useInternalLayout(cardRef);
    var isBannerMode = mode === 'banner';
    function renderAnnouncement() {
        switch (variant) {
            case 'success':
                return _jsx(ScreenReaderOnly, { children: "Success:" });
            case 'warning':
                return _jsx(ScreenReaderOnly, { children: "Warning:" });
            case 'error':
                return _jsx(ScreenReaderOnly, { children: "Error:" });
            default:
                return null;
        }
    }
    function renderAction() {
        var isUpgrade = variant === 'upgrade';
        if (action) {
            // Pass inverted and upgrade style flags
            return (_jsx("div", __assign({ css: actionStyle({ layout: layout, isUpgrade: isUpgrade }) }, { children: cloneElement(action, {
                    inverted: inverted,
                    isUpgrade: isUpgrade,
                }) })));
        }
        return null;
    }
    return (_jsx(NotificationCard, __assign({}, {
        variant: variant,
        hideLeftDecor: isBannerMode,
        isContentCentered: isBannerMode && layout === 'horizontal',
        inverted: inverted,
        closable: closable,
        closeButtonOverride: closeButtonOverride,
        onClose: onClose,
    }, restProps, { ref: cardRef, css: notificationStyle({ isBannerMode: isBannerMode, variant: variant, inverted: inverted, isVisible: isVisible }) }, { children: _jsxs("div", __assign({ css: contentStyle({ layout: layout, isBannerMode: isBannerMode }) }, { children: [_jsxs("div", __assign({ css: textContentStyle({ layout: layout }) }, { children: [_jsxs(Heading, __assign({ as: "h2", size: "medium", inverted: inverted, css: titleStyle() }, { children: [renderAnnouncement(), title] })), description && (_jsx(Paragraph, __assign({ variant: "primary", inverted: inverted, css: descriptionStyle() }, { children: description })))] })), renderAction()] })) })));
}
export default Card;
